import React from 'react';
import { EventDetailsMainInner } from '../EventDetails/EventDetails';

export const MoreEventsSection = ({
    shouldShowMoreEventsFromThisOrganizer,
    isEventActive,
}: {
    shouldShowMoreEventsFromThisOrganizer: boolean;
    isEventActive: boolean;
}) => {
    if (!isEventActive) {
        return null;
    }

    return (
        <EventDetailsMainInner>
            {shouldShowMoreEventsFromThisOrganizer && (
                <div id="listings-root__more-events-from-this-organizer"></div>
            )}
            <div id="listings-root__collections-related-to-this-event"></div>
        </EventDetailsMainInner>
    );
};
